import * as axios from 'axios';
import { getAuthHeader } from '../utils';

export const loiformdata = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-candidate-loi-form-data?APPLICATION_ID=${model.aid}&source=${model.source}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const onSendOfferLetter = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-generate-offer-letter`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const EmployerContactUs = (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/recruit-contact-us`;
    return axios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


